import * as React from "react";
import { cx } from "../../utils/dom";
import {
  BorderRadius,
  ButtonAppearanceSchemaType,
  Color,
  InputAppearance,
} from "../../utils/theme";

interface ThemeProviderValue {
  color?: Color;
  scaling?: SizeScale;
  grayVariant?: string;
  radius?: BorderRadius;
  buttonAppearance?: ButtonAppearanceSchemaType;
  avatarRadiusSize?: BorderRadius;
  inputAppearance?: InputAppearance;
}
interface ThemeProviderProps extends ThemeProviderValue {
  children?: React.ReactNode;
  className?: string;
}

type SizeScale = "90%" | "95%" | "100%" | "105%" | "110%";

const ThemeContext = React.createContext<ThemeProviderValue | null>(null);

export function ThemeProvider(props: ThemeProviderProps) {
  const { children, className, scaling = "100%", ...themeProps } = props;
  return (
    <ThemeContext.Provider value={themeProps}>
      <div
        id="parrot-theme-provider"
        data-gray-variant={themeProps.grayVariant}
        data-radius={themeProps.radius}
        data-color={themeProps.color}
        data-scaling={scaling}
        className={cx(["parrot-theme", className])}
      >
        {children}
      </div>
    </ThemeContext.Provider>
  );
}

export function useTheme(options?: { requireThemeProvider: boolean }) {
  const theme = React.useContext(ThemeContext);
  if (!theme && options?.requireThemeProvider)
    throw new Error("No theme found");
  return theme;
}
